import { parse } from "date-fns";

import { IInvoice, IInvoiceItem } from "interfaces/entities/invoice";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeItems(items: any[]): IInvoiceItem[] {
  return items.map(item => ({
    description: item.description,
    quantity: item.quantity,
    origin: item.origin,
    totalAmountCents: item.total_amount_cents,
    unitAmountCents: item.unit_amount_cents,
  }));
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserialize(invoice: { [key: string]: any }): IInvoice {
  return {
    id: invoice.number,
    createdAt: parse(invoice.created_at),
    status: invoice.state,
    currency: invoice.currency,
    totalCents: invoice.total_cents,
    items: deserializeItems(invoice.items),
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeCollection(invoices: any[]): IInvoice[] {
  return invoices.map(invoice => deserialize(invoice));
}
